module.exports = __webpack_public_path__ + "assets/img/DataVisualization.dc40ef6a.png";